import { useEffect } from 'react';

import { executeQueue } from '@/store/actions.ts';

/** Polls the popup queue on an interval (shared by home route and Test UI). */
export function useDisplayQueuePolling() {
  useEffect(() => {
    const queueInt = setInterval(() => {
      executeQueue();
    }, 500);
    return () => clearInterval(queueInt);
  }, []);
}
